/**
 * Header: keep clicks on direct contact links (phone/email) from bubbling into
 * parent menu toggles.
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.header-contact-redirect').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    });
});
